const contactBackButtonControl = () =>{
    if(document.querySelector('.kruse-custom-back-button')){
        document.addEventListener('click', ev =>{
            if(!ev.target.closest('.kruse-custom-back-button')) return;
            ev.preventDefault();
            const ref = document.referrer;
            const homeUrl = wp_environment.home_url;
            if(ref.includes(homeUrl)){
                window.location.href = ref;
            }
            else{
                window.location.href = homeUrl;
            }
        })
    }
}
export default contactBackButtonControl;